export default "__VITE_ASSET__NQkagm_7__"